import { motion } from 'motion/react';

type Props = {
  size?: number;
};

export const EmptyThreadViewGraphic = ({ size = 1000 }: Props) => (
  <motion.svg
    xmlns='http://www.w3.org/2000/svg'
    id='Layer_1'
    viewBox='0 0 363.49 401.62'
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    css={{
      height: size,
      width: size,
      '.b, .c, .d, .e, .f': {
        fill: 'none',
      },
      '.b, .g, .h, .i, .j, .k, .l, .m, .n': {
        strokeWidth: '0px',
      },

      '.c': {
        stroke: '#6ba6ff',
        strokeMiterlimit: '10',
        strokeWidth: '7px',
      },

      '.c, .d, .e, .f': {
        strokeLinecap: 'round',
      },

      '.d': {
        stroke: '#dcebfe',
        strokeWidth: '6px',
      },

      '.d, .e, .f': {
        strokeMiterlimit: '3',
      },

      '.e': {
        stroke: '#002f75',
        strokeWidth: '17.42px',
      },

      '.f': {
        stroke: '#fff',
        strokeWidth: '5px',
      },

      '.g': {
        fill: '#3f8bfd',
      },

      '.h': {
        fill: '#dcebfe',
      },

      '.i': {
        fill: '#6ba6ff',
      },

      '.j': {
        fill: '#9ec5ff',
      },

      '.k': {
        fill: '#fff',
      },

      '.l': {
        fill: '#ffc700',
      },

      '.m': {
        fill: '#ebf3ff',
      },

      '.n': {
        fill: '#002f75',
      },
    }}
  >
    <circle className='m' cx='183.03' cy='239.12' r='162.5' />
    <rect className='l' x='-.49' y='227.37' width='36.27' height='23.19' rx='11.6' ry='11.6' />
    <path
      className='l'
      d='M44.27,230.5v16.94c0,1.21-1.46,1.81-2.31.96l-8.47-8.47c-.53-.53-.53-1.39,0-1.91l8.47-8.47c.85-.85,2.31-.25,2.31.96Z'
    />
    <circle className='m' cx='7.27' cy='235.46' r='1.53' />
    <rect className='h' x='317.58' y='185.02' width='36.27' height='23.19' rx='11.6' ry='11.6' />
    <path
      className='h'
      d='M362.34,188.15v16.94c0,1.21-1.46,1.81-2.31.96l-8.47-8.47c-.53-.53-.53-1.39,0-1.91l8.47-8.47c.85-.85,2.31-.25,2.31.96Z'
    />
    <circle className='m' cx='325.34' cy='193.11' r='1.53' />
    <rect className='h' x='-1.15' y='166.3' width='19.39' height='12.4' rx='6.2' ry='6.2' />
    <path
      className='h'
      d='M22.77,167.97v9.05c0,.64-.78.97-1.24.51l-4.53-4.53c-.28-.28-.28-.74,0-1.02l4.53-4.53c.46-.46,1.24-.13,1.24.51Z'
    />
    <circle className='m' cx='2.99' cy='170.62' r='.82' />
    <rect className='j' x='130.67' y='113.01' width='19.39' height='12.4' rx='6.2' ry='6.2' />
    <path
      className='j'
      d='M154.59,114.68v9.05c0,.64-.78.97-1.24.51l-4.53-4.53c-.28-.28-.28-.74,0-1.02l4.53-4.53c.46-.46,1.24-.13,1.24.51Z'
    />
    <circle className='m' cx='134.81' cy='117.34' r='.82' />
    <rect className='j' x='69.81' y='192.02' width='226.25' height='120.26' rx='22.05' ry='22.05' />
    <path className='k' d='M217.74,362.59h-88.78c-6.13,0-11.09-4.97-11.09-11.09v-69.58h129.98v50.56l-30.11,30.11Z' />
    <path className='h' d='M217.74,362.59v-24.09c0-3.33,2.7-6.02,6.02-6.02h24.09s-30.11,30.11-30.11,30.11Z' />
    <line className='d' x1='144.42' y1='295.93' x2='221.31' y2='295.93' />
    <line className='d' x1='144.42' y1='311.52' x2='221.31' y2='311.52' />
    <line className='d' x1='144.42' y1='326.76' x2='179.75' y2='326.76' />
    <circle className='i' cx='96.91' cy='242.72' r='4.87' />
    <circle className='i' cx='113.35' cy='242.72' r='4.87' />
    <line className='c' x1='109.61' y1='278.54' x2='256.11' y2='278.54' />
    <circle className='j' cx='239.9' cy='58.86' r='15.26' />
    <circle className='j' cx='273.43' cy='36' r='12.71' />
    <circle className='j' cx='245.35' cy='7.54' r='7.54' />
    <path className='e' d='M266.98,94.49v119.97c0,20.71-16.79,37.5-37.5,37.5h-34.86' />
    <rect className='h' x='162.75' y='172.7' width='40.33' height='57.33' rx='20.17' ry='20.17' />
    <path
      className='g'
      d='M182.92,234.05h-.08c-8.99-.03-17.28-5.3-21.12-13.43-.69-1.47-.06-3.22,1.4-3.91,1.47-.7,3.22-.06,3.91,1.4,2.87,6.09,9.09,10.04,15.83,10.06h.06c6.78,0,13.03-3.95,15.92-10.07.69-1.46,2.43-2.1,3.91-1.4,1.47.69,2.09,2.44,1.4,3.91-3.86,8.16-12.19,13.43-21.23,13.43Z'
    />
    <path
      className='h'
      d='M137.77,229.66c-24.17,0-43.76-19.59-43.76-43.76h0c0-24.17,19.59-43.76,43.76-43.76h90.33c24.17,0,43.76,19.59,43.76,43.76h0c0,24.17-19.59,43.76-43.76,43.76h0c-18.94,0-35.06-12.04-41.15-28.87-.62-1.7-2.21-2.85-4.02-2.85h0c-1.81,0-3.4,1.15-4.02,2.85-6.09,16.84-22.21,28.87-41.15,28.87h0Z'
    />
    <path
      className='g'
      d='M228.1,155.14c16.96,0,30.76,13.8,30.76,30.76s-13.8,30.76-30.76,30.76c-12.91,0-24.53-8.16-28.92-20.3-2.47-6.83-9-11.43-16.24-11.43s-13.77,4.59-16.24,11.43c-4.39,12.14-16.02,20.3-28.92,20.3-16.96,0-30.76-13.8-30.76-30.76s13.8-30.76,30.76-30.76h90.33M228.1,142.14h-90.33c-24.17,0-43.76,19.59-43.76,43.76h0c0,24.17,19.59,43.76,43.76,43.76h0c18.94,0,35.06-12.04,41.15-28.87.62-1.7,2.21-2.85,4.02-2.85s3.4,1.15,4.02,2.85c6.09,16.84,22.21,28.87,41.15,28.87,24.17,0,43.76-19.59,43.76-43.76h0c0-24.17-19.59-43.76-43.76-43.76h0Z'
    />
    <path
      className='b'
      d='M157.92,196.01c.01-2.72-2.19-4.93-4.91-4.95-2.72-.01-4.93,2.18-4.95,4.91-.01,2.72,2.19,4.93,4.91,4.95,2.72.01,4.93-2.18,4.95-4.91Z'
    />
    <path
      className='b'
      d='M217.8,196.01c.01-2.72-2.19-4.93-4.91-4.95-2.72-.01-4.93,2.18-4.95,4.91-.01,2.72,2.19,4.93,4.91,4.95,2.72.01,4.93-2.18,4.95-4.91Z'
    />
    <line className='f' x1='131.46' y1='169.24' x2='120.39' y2='180.31' />
    <line className='f' x1='243' y1='169.24' x2='231.93' y2='180.31' />
    <line className='f' x1='145.48' y1='170.7' x2='123.31' y2='192.87' />
    <rect
      className='j'
      x='203.09'
      y='248.21'
      width='26.32'
      height='5.64'
      transform='translate(467.28 34.78) rotate(90)'
    />
    <path
      className='n'
      d='M140.89,197.75c0,1-.81,1.8-1.8,1.8s-1.8-.81-1.8-1.8c0-2.49,1.01-4.74,2.64-6.36,1.63-1.63,3.88-2.64,6.36-2.64s4.74,1.01,6.36,2.64,2.64,3.88,2.64,6.36c0,1-.81,1.8-1.8,1.8s-1.8-.81-1.8-1.8c0-1.49-.6-2.84-1.58-3.81-.98-.98-2.32-1.58-3.81-1.58s-2.84.6-3.81,1.58c-.98.98-1.58,2.32-1.58,3.81h0Z'
    />
    <path
      className='n'
      d='M228.59,197.75c0,1-.81,1.8-1.8,1.8s-1.8-.81-1.8-1.8c0-1.49-.6-2.84-1.58-3.81-.98-.98-2.32-1.58-3.81-1.58s-2.84.6-3.81,1.58c-.98.98-1.58,2.32-1.58,3.81,0,1-.81,1.8-1.8,1.8s-1.8-.81-1.8-1.8c0-2.49,1.01-4.74,2.64-6.36,1.63-1.63,3.88-2.64,6.36-2.64s4.73,1.01,6.36,2.64c1.63,1.63,2.64,3.88,2.64,6.36h0Z'
    />
  </motion.svg>
);
